import axios from 'axios';
import { Logger } from 'emrn-hybrid/Logger';
import { Passport } from 'emrn-hybrid/Passport';
import { invoke } from 'emrn-hybrid/invoke';
import { isAppVersionGE } from 'emrn-hybrid/isAppVersionGE';
import { Platform } from 'react-native';

/**
 * 调用打点接口
 */
export async function point(svrUrl: string): Promise<any> {
  const { info: passport } = await Passport.getUserInfo();
  const securityInfo: any = await invoke('Container', 'getSecurityInfo');
  let gtoken = '';
  if (securityInfo && securityInfo?.gToken) {
    gtoken = securityInfo?.gToken;
  }
  let appRes = await isAppVersionGE('10.20.0');
  if (appRes && Platform.OS === 'ios') {
    try {
      const triggerSecurityInfoUploadRes: any = await invoke('Container', 'triggerSecurityInfoUpload');
    } catch (error) {}
  }
  const url = `${svrUrl}/bd-blink-server/asyncgapi/web_event.gif?elem=&eventtype=click&url=${svrUrl}/Invite&pvi=${gtoken}&userid=${
    passport?.uid || ''
  }`;
  //console.info(url)
  const param = {
    method: 'get',
    url: url,
    headers: {
      'Cache-control': 'no-cache',
      'Content-Type': 'application/json; charset=utf-8',
    },
    timeout: 15 * 1e3,
  };
  return request(param);
}

function request(options: any) {
  console.log('%c [request]:', 'color: #3381e3', options);
  Logger.info({ tag: 'invite', msg: `[请求WAF接口入参]: ${JSON.stringify(options)}` });
  return new Promise((resolve, reject) => {
    axios(options)
      .then(res => {
        const status = res.status;
        if (status === 200) {
          console.log(`%c [response] ${options.url}: `, 'color: #ea5504', res.data);
          const { code, message } = res.data;
          Logger.info({ tag: 'invite', msg: `[请求成功(${options.url})]: code=${code}, message=${message}` });
          return resolve(res.data);
        } else {
          Logger.info({ tag: 'invite', msg: `[请求失败(${options.url})]: status = ${status}` });
          reject(status);
        }
      })
      .catch(error => {
        Logger.info({ tag: 'invite', msg: `[请求失败(${options.url})]: ${error}` });
        console.log(`[request on error]: ${error.stack}`);
        reject(error);
      });
  });
}
